import React, { useState } from 'react'
import { Table, Empty, Popconfirm, Tooltip, message, Divider } from 'antd'
import { Badge } from 'reactstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBarcode, faRefresh, faTrash, faFileLines } from '@fortawesome/free-solid-svg-icons'
import moment from 'moment'

import Pagination from '../../../components/Pagination'
import CommentsActionButton from '../../Comments/partials/CommentsActionButton'
import NewAppointmentModal from './NewAppointmentModal'
import AppointmentBarcodeModal from './AppointmentBarcodeModal'

import { updateAppointment } from '../services'
import { handleError } from '../../../helpers' 
import AppointmentOrdersModal from './AppointmentOrdersModal'

export default function AppointmentsTable({ appointments, reload, reloadOrders, pagination, setPagination }) {
    const [showRescheduleModal, setShowRescheduleModal] = useState(null)
    const [showBarcodeModal, setShowBarcodeModal] = useState(null)
    const [showAppointmentOrdersModal, setShowAppointmentOrdersModal] = useState(null)

	const columns = [
		{
			title: 'Fecha de la cita',
			dataIndex: 'start_at',
		},
        {
            title: 'Estado',
            dataIndex: 'status',
            render: t => <Badge color={t.color}>{t.label}</Badge>,
        },
        {
            title: 'Orden Principal',
            dataIndex: ['order', 'sku'],
        },
		{
			title: 'Items',
			dataIndex: 'order_detail',
            render: (t, r) => (
                <>
                    {t.article_name}<br/>({t.reception_planned_at})<Divider type="vertical" />
                    <div className='btn btn-outline-primary mr-5' onClick={() => setShowAppointmentOrdersModal(r)}>                    
                        <Tooltip title="Articulos Adicionales">
                            <FontAwesomeIcon icon={faFileLines} />
                        </Tooltip>
                    </div>
                </>
            ),
		},
		{
			title: 'Tipo de vehículo',
			dataIndex: 'vehicle_type',
            render: t => `${t.name} (${t.unload_time} min)`,
		},
        {
            title: 'Bodega',
            dataIndex: ['warehouse', 'sku'],
            render: (t, r) => `${t} (${r.warehouse_dock.name})`,
        },
        {
            title: 'Acciones',
            dataIndex: 'id',
            render: (t, r) => (
                <>
                    <CommentsActionButton type="appointment" id={t} />
                    { r.status.allowed_statuses.includes('canceled') && (
                        <Popconfirm
                            title="¿Estás seguro de querer cancelar esta cita?"
                            onConfirm={() => handleUpdate(t, { canceled_at: moment().format('YYYY-MM-DD HH:mm:ss') })}
                            onCancel={() => console.log('cancel')}
                            okText="Si, cancelar"
                            cancelText="No, volver"
                            okButtonProps={{ danger: true }}
                        >
                            <div className='btn btn-outline-danger mr-5'>
                                <Tooltip title="Cancelar cita" placement='bottom'>
                                    <FontAwesomeIcon icon={faTrash} />
                                </Tooltip>
                            </div>
                        </Popconfirm>
                    ) }
                    { r.status.allowed_statuses.includes('attended') && (
                        <>
                            <div className='btn btn-outline-primary mr-5' onClick={() => setShowBarcodeModal(r)}>
                                <Tooltip title="Ver código de barras">
                                    <FontAwesomeIcon icon={faBarcode} />
                                </Tooltip>
                            </div>
                        </>
                    )}
                    { r.status.allow_reschedule && (
                        <>
                            <div className='btn btn-outline-primary mr-5' onClick={() => setShowRescheduleModal(r)}>
                                <Tooltip title="Reagendar cita" placement='bottom'>
                                    <FontAwesomeIcon icon={faRefresh} />
                                </Tooltip>
                            </div>
                        </>
                    )}
                </> 
            )
        }
	]

    const handleUpdate = (id, data) => {
        updateAppointment(id, data)
            .then(res => {
                message.success(res.data.message)
                reload()
            })
            .catch(error => handleError(error))
    }

	return (
		<React.Fragment>
			<Table 
                dataSource={appointments} 
                rowKey={r => r.id} 
                pagination={false} 
                columns={columns} 
                loading={!appointments} 
                locale={{ emptyText: (
                    <Empty
                        description="No se encontraron registros" 
                        imageStyle={{ height: '80px' }}
                    /> 
                )}}
                size="small" 
            />
            <Pagination 
                pagination={pagination} 
                updatePagination={setPagination} 
                reload={reload} 
                className="mb-0" 
            />
            { showRescheduleModal && (
                <NewAppointmentModal
                    visible
                    onClose={() => setShowRescheduleModal(null)}
                    reload={reload}
                    defaultOrder={showRescheduleModal.order}
                    defaultAppointment={showRescheduleModal}
                />
            )}
            { showBarcodeModal && (
                <AppointmentBarcodeModal
                    visible
                    onClose={() => setShowBarcodeModal(null)}
                    appointment={showBarcodeModal}
                />
            )}
            { showAppointmentOrdersModal && (
                <AppointmentOrdersModal
                    visible
                    onClose={() => setShowAppointmentOrdersModal(null)}
                    reload={() => {
                        reload()
                        reloadOrders()
                    }}
                    appointment={showAppointmentOrdersModal}
                />
            )}
		</React.Fragment>
	)
}